import { Box, Select, MenuItem, Stack, Typography } from "@mui/material";
import Flag from "react-world-flags";
import { useTranslation } from "react-i18next";

const idiomas = [
    { code: "es", label: "Español", flag: "ar" },
    { code: "en", label: "English", flag: "gb" },
    { code: "pt", label: "Português", flag: "br" },
];

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: 20,
                right: 20,
                // left: 20,
                zIndex: 1300,
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(20px)",
                borderRadius: 2,
                boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
                p: 1,
                border: "1px solid rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                    boxShadow: "0 15px 35px rgba(0, 0, 0, 0.2)",
                    transform: "translateY(-2px)",
                },
            }}
        >
            <Select
                value={i18n.language}
                onChange={(e) => changeLanguage(e.target.value)}
                size="small"
                fullWidth
                displayEmpty
                MenuProps={{
                    PaperProps: {
                        sx: {
                            mt: 1,
                            borderRadius: 2,
                            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
                            "& .MuiMenuItem-root": {
                                py: 1.5,
                                "&:hover": {
                                    backgroundColor: "rgba(102, 126, 234, 0.1)",
                                },
                            },
                        },
                    },
                }}
                sx={{
                    minWidth: 60,
                    "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "&:hover .MuiOutlinedInput-notchedOutline": { border: "none" },
                    "& .MuiSelect-select": {
                        py: 0.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    },
                }}
                renderValue={(selected) => {
                    const code = selected.slice(0, 2); // solo los primeros 2 caracteres
                    const idioma = idiomas.find((i) => i.code === code);

                    return (
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <Flag
                                code={idioma?.flag || "es"} // fallback por si no encuentra
                                style={{
                                    width: 24,
                                    height: 18,
                                    borderRadius: 2,
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                }}
                            />
                        </Box>
                    );
                }}

            >
                {idiomas.map(({ code, label, flag }) => (
                    <MenuItem key={code} value={code}>
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            <Flag
                                code={flag}
                                style={{
                                    width: 28,
                                    height: 20,
                                    borderRadius: 2,
                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                }}
                            />
                            <Typography variant="body2" fontWeight={500}>
                                {label}
                            </Typography>
                        </Stack>
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}
